"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MENU_ID = exports.USERMENU_ITEM_HEIGHT_CLOSED = exports.USERMENU_ITEM_HEIGHT_OPEN = exports.USER_POPUP_BOTTOM_MARGIN = void 0;
exports.USER_POPUP_BOTTOM_MARGIN = 0;
exports.USERMENU_ITEM_HEIGHT_OPEN = 72;
exports.USERMENU_ITEM_HEIGHT_CLOSED = 72;
exports.MENU_ID = 'user';
